import React from 'react'
import injectSheet from 'react-jss'
import styles from './works.styles'
import dateFns from 'date-fns'
import { Link } from 'react-router-dom'

const Works = ({ classes, pending, id, works, count }) => {
  return (
    <div>
      <div className={classes.heading}>
        <h2>
          Writing collection{' '}
          <small>
            {count} piece{count > 1 ? 's' : ''} to review
          </small>
        </h2>
      </div>
      <ul className={classes.works}>
        {works.map((work, index) => (
          <li
            value={work.id}
            key={work.id}
            className={classes.work}
            id={`metrics__moderation-af-work-thumb--${index}`}>
            <Link
              to={`/assessment-files/${id}/works/${work.id}`}
              className={classes.link}>
              <div className={classes.thumbnail}>
                <div>
                  <span
                    style={{
                      backgroundImage: `url("${work.media &&
                        work.media[0] &&
                        work.media[0].thumb_url}")`
                    }}
                  />
                </div>
              </div>
              <h5 className={classes.workTitle}>{work.title}</h5>
              <span>
                {dateFns.format(work.updated_at, 'MM/DD/YYYY HH:ss') || ''}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default injectSheet(styles)(Works)
